import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

import icons from './assets';
import classNames from 'classnames';

const SectionMultiEnumMaybe = props => {
  const {
    heading,
    options,
    selectedOptions,
    showUnselectedOptions = true,
    showFullWidth = false,
  } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }

  const sectionClass = classNames(
    css.sectionMultiEnum,
    showFullWidth ? css.sectionMultiEnumFullWidth : ''
  );

  return (
    <section className={sectionClass}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        icons={icons}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
